export default "__VITE_ASSET__DNTDKCSB__"